import React from 'react';
import ImagemDefault from 'assets/img/icones/icon-card-default.png';

const LogoDefault = props => {
  return (<img src={ImagemDefault} width="100" heigth="56" alt="Default" />)
};
export default LogoDefault;